import React from 'react'

function SpecialOffer() {
    return (
        <div className=" p-3 bg-image"
        style={{ backgroundImage: "url('https://i.ibb.co/DLQD5bZ/special-offer-bg.png')", backgroundSize: 'cover' }} >

          

        </div>
    )
}

export default SpecialOffer
